'use strict';

var createFragmentArrayParser = require('./src/createFragmentArrayParser.js');
var createFragmentParser = require('./src/createFragmentParser.js');
var fetchGql = require('./src/fetchGql.js');
var getMaybeFragmentData = require('./src/getMaybeFragmentData.js');
var isFragment = require('./src/isFragment.js');
var isTypedFragment = require('./src/isTypedFragment.js');
var normaliseGqlConnectOptions = require('./src/normaliseGqlConnectOptions.js');
var toFragmentDataArray = require('./src/toFragmentDataArray.js');
var withFragment = require('./src/withFragment.js');
var withFragmentArray = require('./src/withFragmentArray.js');



exports.createFragmentArrayParser = createFragmentArrayParser;
exports.createFragmentParser = createFragmentParser;
exports.fetchGql = fetchGql;
exports.getMaybeFragmentData = getMaybeFragmentData;
exports.isFragment = isFragment;
exports.asTypedFragmentArray = isTypedFragment.asTypedFragmentArray;
exports.asTypedFragmentOrNull = isTypedFragment.asTypedFragmentOrNull;
exports.isTypedFragment = isTypedFragment.isTypedFragment;
exports.normaliseGqlConnectOptions = normaliseGqlConnectOptions;
exports.toFragmentDataArray = toFragmentDataArray;
exports.withFragment = withFragment;
exports.withFragmentArray = withFragmentArray;
